export default {
  packsreceipts: {
    title: "Пачки",
    info: {
      modal: {
        title: {
          vagueReadings: "Квитанції з невизначеними показаннями",
          deletedPacksPeriodWith: "Видалені рознесені пачки за період з",
          deletedPacksPeriodBy: "по"
        }
      }
    },
    editForm: {
      modal: {
        title: {
          packageInfo: "Інформація про пачку",
          compensationVisually: "Компенсація інвалідам по зору",
          socialSupplementInfo: "Інформація про соціальну доплату",
          grantInfo: "Інформація про субсидію"
        }
      },
      form: {
        packnumber: "Банківський номер пачки",
        datebank: "Дата по банку",
        codefirme: "Платник",
        accountSender: "Р/рахунок платника",
        kindpay: "Спосіб оплати",
        summa: "Сума",
        sumprof: "За послуги",
        userid: "Оператор",
        quantity: {
          numberSubscribers: "Кількість абонентів",
          numberReceipts: "Кількість квитанцій"
        },
        countband: {
          numberSheets: "Кількість листів",
          numberCountband: "Кількість бандеролей"
        },
        addPayment: "Занести відразу квитанцію по цій пачці?"
      }
    },
    uploadForm: {
      modal: {
        title: "Завантаження файлів"
      },
      form: {
        uploadfile: "Завантаження"
      }
    },
    import: {
      modal: {
        title: {
          payments: "Імпорт платежів",
          subsidies: "Імпорт субсидій"
        }
      },
      form: {
        codeimport: "Тип вхідних даних",
        kindpay: "Спосіб оплати",
        codepayRadio: {
          title: "Призначення платежу",
          file: "Брати з файлу",
          customer: "Встановити своє"
        },
        fileinfo: "Інформація про файл"
      },
      result: {
        success: "Успішно",
        error: "Помилка"
      }
    },
    confirmDateBank: {
      modal: {
        title: "Перевірка дати по банку"
      },
      form: {
        description:
          "Перевірте правильність дати по банку, зазначеної в пачці що імпортується",
        dateBank: "Дата по банку"
      },
      importError: "Не завершена перевірка дати по банку"
    },
    confirmSender: {
      modal: {
        title: "Організація-відправник"
      },
      form: {
        orgSendPack: "Вкажіть організацію, яка відправила пачку",
        rcount: "р/рахунок"
      }
    },
    confirmSenderMfo: {
      modal: {
        title: "Організація-відправник"
      },
      form: {
        mfo: "МФО",
        orgSendPack: "Вкажіть організацію, яка відправила пачку",
        rcount: "р/рахунок"
      }
    },
    confirmDestLink: {
      modal: {
        title: "Опис зв'язку призначення",
        description:
          "Вкажіть яку з призначень платежів відповідає платежу з назвою:",
        code: "код",
        additionallyImport: "Додатково при імпорті такого платежу",
        additionallyMeterReading:
          "заносити показання лічильника, якщо вони вказані"
      },
      importError: "Помилка при імпорті! Не вказано призначення платежу."
    },
    confirmSenderMfoNumber: {
      modal: {
        title: "Організація-відправник",
        description: "Вкажіть організацію, яка відправила пачку",
        mfo: "МФО",
        number: "Номер"
      },
      importError:
        "Помилка при імпорті! Не вказана організація, яка відправила пачку."
    },
    statusModify: {
      add: "Додавання",
      edit: "Зміна",
      delete: "Сторнування"
    },
    confirmImport: {
      title: "Імпорт"
    },
    importFiles: {
      error: "Порушення структури реєстру в файлі",
      sender: "Відправник",
      datapack: "Дата",
      countpack: "Кількість",
      summapack: "Сума",
      kompack: "Комісійні",
      denyChangeListFiles: "Зміна списку файлів після імпорту неможлива",
      importedFiles: "Імпортовано файлів: {files}",
      noAvailableImportFiles: "Немає доступних для імпорту файлів",
      alert: {
        message: "Імпорт пачок завершений",
        title: "Імпорт"
      }
    },
    postingBtn: {
      confirm: {
        postingPack: "Рознести пачку",
        summaPack: "на суму",
        senderPack: "відправник",
        title: "Рознесення"
      }
    }
  }
};
